import { MessageBar, Text, MessageBarType, PrimaryButton, Stack, TextField, Button, Label, IconButton } from '@fluentui/react';
import axios from 'axios';
import * as React from 'react';
import { validateEmail } from '../../../Tools/Validation';
import { useLocation } from 'react-router-dom';

interface INewOrderStepEmailProps {
    email: string;
    emailChanged: (email: string) => void;
    emailChecked: boolean;
    checkEmail: (mail: string) => void;
    emailExists?: boolean;
    goToStep: (step: number) => void;
    isAuth: boolean;
    goBack: () => void;
}

 
export const NewOrderStepEmail: React.FunctionComponent<INewOrderStepEmailProps> = (props) => {
    const [lastChange, setLastChange] = React.useState<any>();
    const [emailFormatErrorMessage, setEmailFormatErrorMessage] = React.useState<string>();
    const location = useLocation();
    const onEmailChanged = (event?: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>, newValue?: string) => {
        if (newValue) {
            if (lastChange) {
                clearTimeout(lastChange);
                setLastChange(undefined);
            }
            if (validateEmail(newValue)) {
                setEmailFormatErrorMessage(undefined);
                var timer = setTimeout(() => { props.checkEmail(newValue) }, 800)
                setLastChange(timer);
            }
            else {
                setEmailFormatErrorMessage("Prosím zadejte platnou emailovou adresu");
            }

            props.emailChanged(newValue)
        }
        else {
            if (lastChange) {
                clearTimeout(lastChange);
                setLastChange(undefined);
            }
            props.emailChanged("");
        }
    }

    const goToNextStep = () => {
        props.goToStep(3);
    }
 
    return (<Stack>
        <h2>Mám už účet ?</h2>
        <Stack styles={{ root: { width: '100%', maxWidth: 800 } }}>
            <TextField required placeholder="Prosím zadejte váš e-mail" value={props.email} label="Začněte zadáním e-mailu" onChange={onEmailChanged} errorMessage={emailFormatErrorMessage} />
        <Stack styles={{ root: { paddingTop: 10 } }}>
            {props.emailExists != undefined ?
                props.emailExists ?
                    <>
                        <MessageBar messageBarType={MessageBarType.warning}>
                            Již máte registraci, před pokračováním se prosím přihlaste
                            <br />
                            <br />
                            <div style={{ alignItems: 'center', textAlign: 'center' }}>
                                <PrimaryButton text="Přihlásit se" onClick={() => { window.location.href = `/Identity/Account/Login?ReturnUrl=${window.location.pathname + window.location.search}` }} />
                            </div>
                        </MessageBar>
                    </>
                    :
                    <>
                        <MessageBar messageBarType={MessageBarType.warning} >Zadaný e-mail ještě není registrovaný, po dokončení objednávky vám bude zároveň vytvořena registrace</MessageBar>
 
                        <Stack styles={{ root: { paddingTop: 10, paddingBottom:20 } }}>
                                <Label styles={{ root: { padding: 20 } }}>Nebo se přihlašte svím existujícím účtem</Label>
                                <Stack horizontal styles={{ root: { paddingLeft: 20 } }} tokens={{ childrenGap: 15 }}>
                                    <form id="external-account" action={"/Identity/Account/ExternalLogin?returnUrl=" + encodeURIComponent(location.pathname + location.search)}
                                        method="post"
                                         asp-route-returnUrl="@Model.ReturnUrl" >
                                    <button type="submit" style={{ backgroundColor: 'white', borderWidth:0 }} name="provider" value="Google" title="Přihlášení účtem Google">
                                        <img src="/img/Ikony/google.svg" style={{ height: 64 }} />
                                    </button>
                                        <button type="submit" name="provider" style={{ backgroundColor: 'white', borderWidth: 0 }}  value="Microsoft" title="Přihlášení účtem Microsoft">
                                        <img src="/img/Ikony/microsoft.svg" style={{ height: 64 }} />
                                        </button>
                                        </form>
                                </Stack>
                        </Stack>
                    </>
                : null}
            </Stack>
            <Stack horizontal wrap horizontalAlign="center" tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: 20 } }}>
                <Button text="< Zpět" onClick={props.goBack} />
                <PrimaryButton disabled={!props.emailChecked || (props.emailExists && !props.isAuth) } text="Pokračovat >" onClick={goToNextStep} />
            </Stack>
            </Stack>
    </Stack>)
}
